import axios from 'axios';
import getExpConfig from '../utils/getExpConfig';
import { recordApiResponse, API_ENDPOINT_GET_QUICK_VIEW_PRICING } from '../utils/newRelic';

export const quickViewPricingApi = (params) => {
  const url = `${getExpConfig(
    'sku-mapping-api-base-url'
  )}/api/GetQuickViewPricingAndSkuAvailability`;
  const promise = axios.get(url, { params });
  return recordApiResponse(promise, API_ENDPOINT_GET_QUICK_VIEW_PRICING, url, params).then(
    (response) => response.data
  );
};
